import React, { useState } from "react";
import "./DuePaymentModal.css";

const DuePaymentModal = ({ onClose }) => {
  const [payable, setPayable] = useState("");

  return (
    <div className="duePayment-modal-overlay">
      <div className="modal">
        <button className="close-btn" onClick={onClose}>×</button>

        <h2 className="modal-title">Due amount</h2>

        <div className="info">
          <p><span>Payment for:</span> Chalk, Chair, Duster</p>
          <p><span>Total amount:</span> ₹ 43,790</p>
          <p><span>Due payment:</span> ₹ 10,120</p>
        </div>

        <div className="input-group">
          <label>Payable amount</label>
          <input
            type="number"
            placeholder="Enter amount that you pay now"
            value={payable}
            onChange={(e) => setPayable(e.target.value)}
          />
        </div>

        <p className="note">
          Pay full as soon as possible. otherwise it effects on revenue section
          that is calculated monthly.
        </p>

        <button className="confirm-btn">Confirm payment</button>
      </div>
    </div>
  );
};

export default DuePaymentModal;
